var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageLayout',{staticClass:"clients-page"},[_c('PageTitle',{staticClass:"page-title"},[_vm._v("Клієнти")]),_c('ClientFullInfo')],1)}
var staticRenderFns = []

export { render, staticRenderFns }